import React from "react";
import FluidImage from "../../../components/fluidImage";
import Link from "../../../utils/link";

const ImageWithTitleGrid = (props) => {

    const blok = props.blok;
    const blocks = blok.blocks;

    return(
        <section className="width grid lg:grid-cols-3 gap-2 lg:gap-6">
            {
                blocks.map((block, index) => {
                    return(
                        <div key={blok.uid} className="flex flex-col relative group">
                            <div className="overflow-hidden">
                            <FluidImage image={block.image} className='aspect-[375/250] lg:aspect-[430/540] group-hover:opacity-75 group-hover:scale-105 duration-1000'/>
                            </div>
                            {
                                block.title != "" && (
                                    <p className="font-semibold text-lg mt-2 lg:mt-4">
                                        {block.title}
                                    </p>
                                )
                            }
                            {
                                block.link?.cached_url != undefined && (
                                    <Link to={block.link.cached_url} className='w-full h-full absolute inset-0'> <span className="sr-only">{block.title}</span> </Link>
                                )
                            }
                        </div>  
                    )
                })
            }
        </section>
    )
}

export default ImageWithTitleGrid;